import { Injectable } from '@angular/core';
import { Validators } from '@angular/forms';
import {
  Dropdown,
  Container,
  Legend,
  CondicionControl,
  BaseControl,
  Textbox,
  Custom,
  TipoControl,
  Option,
  DateTimePicker
} from '@app/shared';

@Injectable()
export class CondictionsMasterTableFormsService {
  constructor() { }

  /**
   * Crea el formulario de creacion o edicion de las condiciones para los campos de los formularios
   *
   * @param {*} template
   * @param {*} options
   * @param {CondicionControl} [condition]
   * @param {TipoControl} [typeField]
   * @returns {BaseControl<any>[]}
   * @memberof CondictionsMasterTableFormsService
   */
  getFormCondictionControl(
    template: any,
    options: any, condition?: CondicionControl,
    typeField?: TipoControl
  ): BaseControl<any>[] {
    let sizeSies = 'col-md-4';
    let controlValor: BaseControl<any>;
    let optionsCondicional: Array<Option> = [
      {key: 'Igual', value: 'Igual'},
      {key: 'Diferente', value: 'Diferente'},
      {key: 'Vacio', value: 'Vacio'},
    ];

    if (
      typeField &&
      (typeField.nombre === 'number' || typeField.nombre === 'date-time-picker')
    ) {
      optionsCondicional = [
        {key: 'Igual', value: 'Igual'},
        {key: 'Diferente', value: 'Diferente'},
        {key: 'Mayor a', value: 'Mayor a'},
        {key: 'Mayor o igual a', value: 'Mayor o igual a'},
        {key: 'Menor a', value: 'Menor a'},
        {key: 'Menor o igual a', value: 'Menor o igual a'},
        {key: 'Vacio', value: 'Vacio'},
      ];
    }

    if (condition) {
      if (condition.siEs) {
        controlValor = this.getFormValor(condition.siEs, condition.valor, template, options, typeField);
        if (condition.siEs === 'Vacio') {
          sizeSies = 'col-md-6';
        } else if (typeField && typeField.nombre === 'date-time-picker') {
          sizeSies = 'col-12';
          if (controlValor['controls'] && controlValor['controls'].length) {
            controlValor['controls'][1]['value'] = condition ? condition.fechaActual ? true : false : false;
          }
        }
      }
    }

    if (!controlValor) {
      if (typeField && typeField.nombre === 'checkbox') {
        controlValor = new Dropdown({
          key: 'txtValor',
          label: 'Valor:',
          value: condition ? condition.valor : null,
          options: [
            {key: 'true', value: 'Seleccionado'},
            {key: 'false', value: 'No seleccionado'},
          ],
          size: sizeSies,
          placeholder: 'Ingresar el alias de la asociacion que contiene la forma',
          validations: {
            validators: [Validators.required]
          }
        });
      } else if (typeField && typeField.nombre === 'ngSelect') {
        controlValor = new Custom({
          key: 'txtValor',
          label: 'Valor:',
          template: template,
          value: condition ? condition.valor : null,
          options: options['optColumnMaster'] ? options['optColumnMaster'] : [],
          size: sizeSies,
          placeholder: 'Seleccione el valor',
          validations: {
            validators: [Validators.required]
          }
        });
      } else if (typeField && typeField.nombre === 'date-time-picker') {
        controlValor = new Container(
          {
            class: 'form-row form-check form-check-inline col-12',
            controls: [
              new DateTimePicker({
                key: 'txtValor',
                label: 'Valor:',
                value: condition ? condition.valor ? new Date(condition.valor) : null : null,
                size: 'col-md-10',
                pickerType: options['tipo'] ? options['tipo'] : null,
                placeholder: 'Seleccione el valor',
                validations: {
                  validators: [Validators.required]
                },
                condictions: [
                  {
                    campoDepende: 'chFechaActual',
                    siEs: 'Igual',
                    valor: 'true',
                    accion: 'Bloquear',
                  }
                ],
              }),
              new Textbox({
                key: 'chFechaActual',
                type: 'checkbox',
                value: condition ? condition.fechaActual ? true : false : false,
                label: 'Fecha actual',
                size: 'col-md-2',
              }),
            ]
          }
        );
        sizeSies = 'col-12';
      } else {
        controlValor = new Textbox({
          key: 'txtValor',
          label: 'Valor:',
          value: condition ? condition.valor : null,
          size: sizeSies,
          placeholder: 'Ingresar el alias de la asociacion que contiene la forma',
          validations: {
            validators: [Validators.required]
          }
        });
      }
    }

    const controls: BaseControl<any>[] = [
      new Legend({
        value: 'Depende de:',
        order: 1
      }),
      new Container({
        class: 'form-row form-check form-check-inline col-12',
        order: 2,
        controls: [
          new Custom({
            key: 'cboFieldInit',
            label: 'Campo Depende:',
            value: condition ? condition.campoDepende : null,
            template: template,
            options: options['fieldInit'] ? options['fieldInit'] : [],
            size: 'col-md-12',
            placeholder: 'Seleccionar el campo del cual depende la validacion',
            validations: {
              validators: [Validators.required]
            }
          }),
        ]
      }),
      new Legend({
        value: 'Condicion:',
        order: 3
      }),
      new Container({
        class: 'form-row form-check form-check-inline col-12',
        order: 4,
        controls: [
          new Dropdown({
            key: 'cboSiEs',
            label: 'Condicional a operar:',
            value: condition ? condition.siEs : '',
            options: optionsCondicional,
            size: sizeSies,
            placeholder: 'Seleccionar el condicional a operar',
            validations: {
              validators: [Validators.required]
            }
          }),
          controlValor,
          new Dropdown({
            key: 'cboAction',
            label: 'Accion:',
            options: [
              {key: 'Bloquear', value: 'Bloquear'},
              {key: 'Desbloquear', value: 'Desbloquear'},
              {key: 'Ocultar', value: 'Ocultar'},
              {key: 'Mostrar', value: 'Mostrar'},
              {key: 'Validar expresion', value: 'Validar expresion'},
              {key: 'Limpiar expresion', value: 'Limpiar expresion'},
            ],
            value: condition ? condition.accion : null,
            size: sizeSies,
            placeholder: 'Seleccione el operador para la condición siguiente',
            validations: {
              validators: [Validators.required]
            }
          }),
        ]
      }),
      new Textbox({
        key: 'txtCondExpresion',
        label: 'Expresion regular:',
        value: condition ? condition.expresion ? condition.expresion : '' : '',
        order: 5,
        placeholder: 'Expresion regular',
        validations: {
          validators: [Validators.required]
        },
        condictions: [
          {
            campoDepende: 'cboAction',
            siEs: 'Igual',
            valor: 'Validar expresion',
            accion: 'Mostrar',
          }
        ]
      }),
      new Textbox({
        key: 'txtCondErrorExpresion',
        label: 'Mensaje de error:',
        value: condition ? condition.mensajeExpresion: '',
        order: 6,
        placeholder: 'Mensaje de error de la expresion regular',
        condictions: [
          {
            campoDepende: 'cboAction',
            siEs: 'Igual',
            valor: 'Validar expresion',
            accion: 'Mostrar',
          }
        ]
      }),
      new Custom({
        key: 'cboOperactorNext',
        label: 'Siguiente operador de condicion:',
        order: 7,
        template: template,
        options: [
          {key: 'O', value: 'O'},
          {key: 'Y', value: 'Y'},
        ],
        value: condition ? condition.operadorCondicion : '',
        placeholder: 'Seleccione el operador para la condición siguiente',
        validations: {
          validators: []
        }
      }),
    ];

    return controls.sort((a, b) => a.order - b.order);
  }

  /**
   *  Retorna el control de valor dependiendo de lo seleccionado en el control de si es
   *
   * @private
   * @param {string} operactorCondiction
   * @param {*} value
   * @param {*} template
   * @param {*} options
   * @param {TipoControl} typeField
   * @returns {BaseControl<any>}
   * @memberof CondictionsMasterTableFormsService
   */
  private getFormValor(
    operactorCondiction: string,
    value: any,
    template: any,
    options: any,
    typeField: TipoControl
  ): BaseControl<any> {
    switch (operactorCondiction) {
      case 'Vacio':
        return new Textbox({
          key: 'txtValor',
          label: 'Valor:',
          value: value,
          hidden: true,
          placeholder: 'Ingresar el alias de la asociacion que contiene la forma',
          validations: {
            validators: []
          }
        });
      default:
        if (typeField && typeField.nombre === 'checkbox') {
          return new Dropdown({
            key: 'txtValor',
            label: 'Valor:',
            value: value,
            options: [
              {key: 'true', value: 'Seleccionado'},
              {key: 'false', value: 'No seleccionado'},
            ],
            size: 'col-md-4',
            placeholder: 'Ingresar el alias de la asociacion que contiene la forma',
            validations: {
              validators: [Validators.required]
            }
          });
        } else if (typeField && typeField.nombre === 'date-time-picker') {
          return new Container(
            {
              class: 'form-row form-check form-check-inline col-12',
              controls: [
                new DateTimePicker({
                  key: 'txtValor',
                  label: 'Valor:',
                  value: value ? new Date(value) : null,
                  size: 'col-md-10',
                  pickerType: options['tipo'] ? options['tipo'] : null,
                  placeholder: 'Seleccione el valor',
                  validations: {
                    validators: [Validators.required]
                  },
                  condictions: [
                    {
                      campoDepende: 'chFechaActual',
                      siEs: 'Igual',
                      valor: 'true',
                      accion: 'Bloquear',
                    }
                  ],
                }),
                new Textbox({
                  key: 'chFechaActual',
                  type: 'checkbox',
                  // value: value,
                  label: 'Fecha actual',
                  size: 'col-md-2',
                }),
              ]
            }
          );
        } else if (typeField && typeField.nombre === 'ngSelect') {
          return new Custom({
            key: 'txtValor',
            label: 'Valor:',
            template: template,
            value: value,
            options: options['optColumnMaster'] ? options['optColumnMaster'] : [],
            size: 'col-md-4',
            placeholder: 'Seleccione el valor',
            validations: {
              validators: [Validators.required]
            }
          });
        } else {
          return new Textbox({
            key: 'txtValor',
            label: 'Valor:',
            value: value,
            size: 'col-md-4',
            placeholder: 'Ingresar el alias de la asociacion que contiene la forma',
            validations: {
              validators: [Validators.required]
            }
          });
        }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/administration/teacher/master-structure/condictions-master-table/shared/condictions-master-table.form.service.ts